import React, { useState, useRef, useEffect } from 'react';
// hooks
import { useAlert } from 'react-alert';
// api
import { axios } from '../../../api/axios';
// style
import style from './SearchModal.module.css';
// func
import { scrollEnable } from '../../../func/scroll';
// component
import LoadingInCenter from '../loading/loading-in-center';
import Item from './Item';

export default function ({ closeModal }) {
  const alert = useAlert();

  const [query, setQuery] = useState('');

  const [result, setResult] = useState(null);

  const [loading, setLoading] = useState(false);

  const refInput = useRef({});

  useEffect(() => {
    let timeout = null;

    refInput.current.addEventListener('keyup', (e) => {
      setLoading(true);

      if (timeout) {
        clearTimeout(timeout);
      }

      timeout = setTimeout(() => {
        setQuery(e.target.value);
        setLoading(false);
      }, 600);
    });

    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }

      scrollEnable();
    };
  }, []);

  useEffect(() => {
    if (query.length) {
      setLoading(true);

      axios
        .get(`search/post/code/`, { params: { query } })
        .then((res) => {
          setResult(res.data);
        })
        .catch((err) => {
          console.error('Error Search Code.', err);
          alert.error('جستجو با خطا مواجه شد.');
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setResult(null);
      setLoading(false);
    }
  }, [query]);

  return (
    <div className={style.searchPanel}>
      <div className={style.searchCloseArea} onClick={closeModal} />
      <div className={'card border-none share-modal animation-modal-show ' + style.searchBody}>
        <div className={style.cardHeader}>
          <input
            type={'text'}
            ref={refInput}
            className={'form-control placeholder-rs ' + style.input}
            placeholder={'کد را وارد کنید'}
          />
        </div>
        <div className={'card-body f-grow-1'} style={{ height: 0, overflow: 'auto' }}>
          <LoadingInCenter show={loading} label={'Loading'} fill={'#555555'} width={24} height={24} blur={true} />

          {result === null && <small style={{ textAlign: 'center', opacity: 0.4 }}>لیست خالی</small>}

          {query.length > 0 && result?.length === 0 && (
            <small style={{ textAlign: 'center', opacity: 0.4 }}>موردی یافت نشد</small>
          )}

          {result && result.map((post) => <Item data={post} key={post.post_id} />)}
        </div>
        <div className={'card-footer align-items-center justify-content-center color-danger c-p'} onClick={closeModal}>
          بازگشت
        </div>
      </div>
    </div>
  );
}
